import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getCategoryById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateCategory } from "..";

const EditCategory = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getCategory();
        else setLoading(false);
    }, [id]);

    const getCategory = async () => {
        try {
            const { data } = await getCategoryById(id);
            setItem(data.category);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />

        : item?._id ?
            <CreateCategory from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_category' />
};

export default EditCategory;